import { AiMatchedItem } from 'types/schema';
import { AnalyzedItem } from './types';

export function formatVND(amount: number): string {
  return `${amount.toLocaleString('vi-VN')}₫`;
}

export function mapItemsToProducts(items: AiMatchedItem[]): AnalyzedItem[] {
  return items.map((item, index) => {
    const p = item.matchedProduct;
    const defaultQuantity = p && p.quantity > 0 ? p.quantity : 1;
    return {
      ...item,
      id: p ? `${p.sku}-${index}` : `unmatched-${index}`,
      selected: !!p,
      defaultQuantity: defaultQuantity,
    };
  });
}
